import { Component, computed, input, output, viewChild } from '@angular/core';
import { RidAudioButton } from '../rid-audio-button/rid-audio-button';

@Component({
  selector: 'rid-content-card',
  imports: [RidAudioButton],
  templateUrl: './rid-content-card.html',
})
export class RidContentCard {
  image = input<string>();
  text = input<string>();
  audio = input<string>();
  state = input<'DEFAULT' | 'CORRECT' | 'INCORRECT' | 'DISABLED'>('DEFAULT');
  layout = input<'VERTICAL' | 'HORIZONTAL'>('VERTICAL');

  audioButton = viewChild<RidAudioButton>('audioButton');

  // clickable
  isClickable = input<boolean>(false);
  isClicked = input<boolean>(false);
  clicked = output<void>();

  twBackground = computed(() => {
    const state = this.state();

    if (state === 'DISABLED') return 'bg-surface-300';

    if (state === 'DEFAULT') {
      if (this.isClickable()) {
        return 'cursor-pointer bg-surface-300 hover:bg-blue-500';
      } else return 'bg-surface-300';
    } else {
      return {
        CORRECT: 'bg-emerald-500',
        INCORRECT: 'bg-red-500',
      }[state];
    }
  });

  async present() {
    await this.audioButton()?.play();
  }
}
